<template>
    <v-card v-if="isGroupMember()">
      <v-card-title>
        グループジョブ一覧
        <v-spacer/>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="this['job/groupJobs']" :search="search">
      <template v-slot:[`item.jobName`]="{ item }">
        <router-link :to="{ name: 'GroupJobDetail', params: {job_id: item.jobId} }">
          {{item.jobName}}
        </router-link>
      </template>
      <template v-slot:[`item.jobStatus`]="{ item }">
        {{ dispJobStatus(item) }}
      </template>
      </v-data-table>
    </v-card>
</template>
<script>
  import { mapActions, mapGetters} from "vuex"
  export default {
    name: 'GroupJobListComponent',
    components: {

    },
    computed: {
      ...mapGetters(['group','job/groupJobs','myGroupMembers','loginUserId'])
    },
    data () {
      return {
        search: '',
        headers: [
          {text: 'ジョブ名', align: 'start', sortable: false, value: 'jobName'},
          { text: '開始日', value: 'startDate' },
          { text: '終了日', value: 'finishDate' },
          { text: 'ステータス', value: 'jobStatus' },
        ],
        groups: []
      }
    },
    methods: {
      isGroupMember(){
        const loginUserId = this.loginUserId
        return this.myGroupMembers.some(member => member.userId === loginUserId)
      },
      dispJobStatus(job){
        switch(job.jobStatus){
        case 1:
          return '継続中'
        case 2:
          return '終了'
        case 3:
          return '無効'
        }
      },
      ...mapActions(['job/fetchGroupJobs'])
    }
  }
</script>
